import React from "react";
import Box from "@mui/material/Box";

interface TabPanelProps {
	value: number;
	index: number;
	children: React.ReactNode;
}
export const TabPanel = (props: TabPanelProps) => {
	const { children, value, index, ...other } = props;
	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`sd-tabpanel-${index}`}
			aria-labelledby={`sd-tab-${index}`}
			style={{ width: '100%' }}
			{...other}
		>
			{value === index && <Box display="flex" sx={{ width: '100%' }}>{children}</Box>}
		</div>
	);
};
